<template>
  <div id="TerminalBlocks" class="w-100 h-100">
    <div class="list w-100 p-10" v-if="!isEdit">
      <div class="w-100 d-flex list_top">
        <el-row class="w-100" type="flex" align="middle">
          <el-col :span="22">
            <el-input size="small" v-model="searchKey" placeholder="型号或名称搜索"></el-input>
          </el-col>
          <el-col :span="2" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                type="primary"
                class="iconfont icon-search"
                @click="filterNodeList"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <div class="table-content m-t-10">
        <el-table
          :data="dataList"
          v-loading="tableLoading"
          border
          class="w-100"
          height="100%"
          @select="selectionTableChange"
          ref="nodeTable"
        >
          <el-table-column type="selection" align="center" width="55"> </el-table-column>
          <el-table-column type="index" label="序号" align="center" width="55"> </el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="端子排名称"> </el-table-column>
          <el-table-column prop="code.count" show-overflow-tooltip label="端子排数量">
          </el-table-column>
          <el-table-column prop="code.model" show-overflow-tooltip label="端子型号">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-row v-if="!isEdit" class="w-100 m-t-10" type="flex" align="middle">
      <el-col :span="12">
        <el-button type="primary" size="mini" @click="addNode">新增</el-button>
      </el-col>
      <el-col :span="12" class="tr">
        <el-button type="primary" size="mini" @click="editNode">修改</el-button>
        <el-button type="primary" size="mini" @click="deleteNode">删除</el-button>
      </el-col>
    </el-row>
    <div class="Terminal_top fz-12 p-10" v-if="isEdit">
      <el-row class="w-100" type="flex" aglin="middle">
        <el-col :span="5" class="tr p-r-10"><span>端子头文字</span></el-col
        ><el-col :span="19"
          ><el-input
            placeholder="请输入端子头文字（非必填）"
            v-model="TerminalText"
            size="small"
          ></el-input
        ></el-col>
      </el-row>
      <el-row class="w-100" type="flex" aglin="middle">
        <el-col :span="5" class="tr p-r-10"
          ><span class="terminal-count-title">端子排数量</span></el-col
        ><el-col :span="19">
          <el-input
            size="small"
            placeholder="请输入端子排数量（必填）"
            v-model="TerminalNumber"
            oninput="value = value.replace(/[^\d.]/g,'')"
          ></el-input>
        </el-col>
      </el-row>
    </div>
    <div class="Terminal_bottom p-10 m-t-5 fz-12" v-if="isEdit && !selectionNode">
      <div class="Terminal_bottom_title">
        <el-row class="w-100" type="flex" align="middle">
          <el-col :span="4">
            <span>端子样式</span>
          </el-col>
          <el-col :span="17">
            <el-input size="small" v-model="searchTypeKey" placeholder="名称搜索"></el-input>
          </el-col>
          <el-col :span="3" class="tr">
            <el-tooltip effect="dark" content="搜索" placement="top">
              <el-button
                @click="getDataList"
                type="primary"
                size="small"
                class="iconfont icon-search"
              ></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <div class="model m-t-5">
        <div class="model_card" v-for="(item, index) in deviceList" :key="index">
          <div class="w-100 img-card">
            <img
              class="w-100 h-100"
              :src="`${currentEnv.VUE_APP_PLANT_SERVER}${item.thumbnails}`"
              width="100%"
              height="100%"
              alt=""
            />
          </div>
          <div
            class="w-100 item-title ell tc"
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-checkbox
              v-model="item.select"
              @change="selectChange(item)"
              class="text-color-white d-flex flex-align-center flex-row-center m-t-5"
              >{{ item.name }}</el-checkbox
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="terminal-table w-100 p-10 m-t-10"
      :style="{ height: selectionNode ? 'calc(100% - 150px)' : 'calc(100% - 340px)' }"
    >
      <el-table :data="TerminalObjList" height="100%" border>
        <el-table-column type="index" align="center" width="55" show-overflow-tooltip label="序号">
        </el-table-column>
        <el-table-column prop="number" show-overflow-tooltip label="对象编号"> </el-table-column>
      </el-table>
    </div>
    <div class="card-footer w-100 m-t-10" v-if="isEdit">
      <el-row type="flex" align="middle" v-if="!selectionNode">
        <el-col :span="9">
          <div
            @click="
              (e) => {
                e.stopPropagation()
              }
            "
          >
            <el-radio-group v-model="addTypeValue" class="d-flex flex-align-center">
              <el-radio size="small" :label="1">锚点位置</el-radio>
              <el-radio size="small" :label="2">按节点</el-radio>
            </el-radio-group>
          </div>
        </el-col>
        <el-col :span="8" class="p-l-5 p-r-5">
          <el-select
            v-model="nodePositionValue"
            placeholder="中心"
            size="mini"
            popper-class="document_select-popper"
          >
            <el-option
              v-for="item in nodePostionProp"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="7" class="tr"
          ><el-button size="mini" @click="cancleModify">取消</el-button>
          <el-button type="primary" size="mini" @click="loadDZPHead">新增</el-button></el-col
        >
      </el-row>
      <el-row type="flex" align="middle" class="w-100" v-else>
        <el-col :span="12"> </el-col>
        <el-col :span="12" class="tr"
          ><el-button size="mini" @click="cancleModify">取消</el-button>
          <el-button type="primary" size="mini" @click="saveModifyResult">保存</el-button></el-col
        >
      </el-row>
    </div>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinDocuments from '@/assets/js/api/documents'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import { loadFbxModel, loadPrModel, isJSONObj, generateGUID } from '../../../js/engineerSceneData'

const PlayerProgress = () => {
  return import('@/components/model/PlayerProgress')
}
export default {
  props: ['player', 'updateNode', 'watchNodeModify', 'documentId', 'currentNodeData'],
  mixins: [ApiMixinDocuments, ApiMixinDocumentList],
  components: {
    PlayerProgress,
  },
  name: 'TerminalBlocks',
  data() {
    return {
      currentCreatedNode: null,
      currentTerminalModel: null,
      currentTerMinalMd5: '',
      currentTerminalFile: '',
      currentTerminalInfo: {},
      currentTerminalMaterial: {},
      selectionNode: null,
      terminalParent: null,
      dataName: '',
      circulateNumber: 0,
      // 模型加载相关
      isTags: false,
      // 锚点节点相关start
      radio: '1',
      showLoadProgress: false,
      loadPercentage: 0,
      loadType: '',
      currentCreateParams: {},
      // 模型加载相关
      orignList: [],
      TerminalText: '',
      TerminalNumber: '',
      searchKey: '',
      currentNodeName: '', // 对象名称
      searchTypeKey: '', // 列表搜索
      showListData: true,
      dataList: [],
      deviceList: [],
      tableLoading: false,
      defaultFolderId: null, // 仪器的文件路径id
      templateAttrSetList: [],
      addTypeValue: 1, // 添加类型
      nodePositionValue: 'YN', // 节点位置
      nodePostionProp: [
        {
          value: 'Z',
          label: '上方',
        },
        {
          value: 'ZN',
          label: '下方',
        },
        {
          value: 'YN',
          label: '前方',
        },
        {
          value: 'Y',
          label: '后方',
        },
        {
          value: 'XN',
          label: '左方',
        },
        {
          value: 'X',
          label: '右方',
        },
      ],
      isEdit: false,
      TerminalObjList: [],
      defaultTagFolderId: '',
      defaultDZPHeadFolderId: '', // 端子头
      tagDataList: [],
      terminalHeadList: [],
      currentTagFile: {},
      increasedCount: 0,
      differCount: 0,
      totalTerminalCount: 0,
      terminalHeadCalcAabb: {},
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || this.$store.getters['Sites/currentProject'] || {}
    },
    systemParams() {
      return this.$store.getters.systemParams || []
    },
    DevicesLibrariesFolder() {
      const path = _.find(this.systemParams, { parameterCode: 'DevicesLibrariesFolder' }) || {}
      return path.parameterValue || null
    },
    DevicesClassId() {
      const parameter = _.find(this.systemParams, { parameterCode: 'DevicesClass' }) || {}
      return parameter ? parameter.parameterValue : ''
    },
  },
  watch: {
    // 监听循环次数，每次变化时执行下一次端子模型创建任务
    circulateNumber(newVal) {
      if (newVal < Number(this.TerminalNumber) && newVal !== 0) {
        this.addModel(
          this.currentTerMinalMd5,
          this.currentTerminalFile,
          this.currentTerminalInfo,
          this.currentTerminalMaterial
        )
      }
    },
    async increasedCount(val) {
      if (val < this.differCount && val !== 0) {
        this.addModel(
          this.currentTerMinalMd5,
          this.currentTerminalFile,
          this.currentTerminalInfo,
          this.currentTerminalMaterial
        )
      } else if (val >= this.differCount) {
        this.increasedCount = 0
        this.currentTerMinalMd5 = ''
        this.currentTerminalFile = ''
        this.currentTerminalInfo = {}
        this.currentTerminalMaterial = {}
        this.currentTerminalModel = null
        this.finishUpdate(this.currentCreatedNode)
      }
    },
    updateNode() {
      this.getTerminalBlocksList()
    },
    watchNodeModify() {
      this.getTerminalBlocksList()
    },
    currentNodeData: {
      handler() {
        this.$nextTick(() => {
          this.getTerminalBlocksList()
        })
      },
      deep: true,
    },
  },
  async created() {
    this.getTerminalBlocksList()
    await this.getFolderClassId()
    // 获取属性模板
    await this.getAttributeTemplateList()
    // 获取端子排列表
    this.getDataList()
    await this.getTagFolderClassId()
    await this.getDZPHeadFolderId()
    this.getModelTagList()
    this.getDZPHeadList()
  },
  methods: {
    // 保存端子排编辑结果
    async saveModifyResult() {
      console.log(this.selectionNode)
      await this.updateHeadText()
      await this.updateTerminalCount()
    },
    // 更新端子数量
    async updateTerminalCount() {
      const terminalChilds = await this.player.Native.NodeProxy.getNodeChildren(
        this.selectionNode.nodePtr
      )
      const terminalList = _.filter(terminalChilds, (item) => {
        return isJSONObj(item.code) && JSON.parse(item.code).type === 'TerminalBlocks'
      })
      this.totalTerminalCount = terminalList.length
      if (terminalList.length > 0 && Number(this.TerminalNumber) > terminalList.length) {
        const terminalData = isJSONObj(terminalList[0].code) ? JSON.parse(terminalList[0].code) : {}
        this.differCount = this.TerminalNumber - terminalList.length
        this.increasedCount = 0
        this.currentTerminalModel = terminalData.model
        console.log(_.last(terminalList).item)
        const calcData = await this.player.Native.ModelTree.calcItemAabbData(
          _.last(terminalList).item
        )
        console.log(calcData)
        this.currentCreateParams = {
          TerminalNumber: this.TerminalNumber,
          TerminalText: this.TerminalText,
          modifyNode: null,
          documentDataList: [],
          type: 'TerminalBlocks',
          name: '',
          positionType: 'TerminalBlocks',
          faceValue: this.nodePositionValue,
        }
        const bottomCenter = Aabb.faceCenter(calcData.aabb, 'ZN')
        this.nodePosition = [
          bottomCenter[0],
          bottomCenter[1],
          calcData.aabb[0][2] + (calcData.aabb[1][2] - calcData.aabb[0][2]) / 2,
        ]
        this.addModel(terminalData.md5, terminalData.filePath, terminalData, {
          md5: terminalData.materialFileMd5,
        })
      } else if (terminalList.length > 0 && Number(this.TerminalNumber) < terminalList.length) {
        const diffData = terminalList.splice(this.TerminalNumber, terminalList.length)
        console.log(diffData, 1111111)
        const editNode = await this.player.Native.NodeEditor.node()
        for (let i = 0; i < diffData.length; i += 1) {
          const item = diffData[i]
          // eslint-disable-next-line no-await-in-loop
          if (editNode === item.nodePtr) {
            // eslint-disable-next-line no-await-in-loop
            await this.player.Native.NodeEditor.setNode(0)
          }
          // eslint-disable-next-line no-await-in-loop
          await this.player.Native.NodeProxy.destroyNode(item.nodePtr)
        }
        this.finishUpdate(this.selectionNode.nodePtr)
      }
      console.log(terminalList)
    },
    // 更新完成
    async finishUpdate(node) {
      const terminalChilds = await this.player.Native.NodeProxy.getNodeChildren(
        this.selectionNode.nodePtr
      )
      const terminalList = _.filter(terminalChilds, (item) => {
        return isJSONObj(item.code) && JSON.parse(item.code).type === 'TerminalBlocks'
      })
      this.TerminalObjList = _.map(terminalList, (item) => {
        return { number: item.name }
      })
      this.$emit('updateEditTree', node)
    },
    // 更新端子头文字
    async updateHeadText() {
      const tagNode = await this.player.Native.NodeProxy.findFirstNodeByName(
        this.selectionNode.nodePtr,
        'Title_Small'
      )
      const tagNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(tagNode)
      const terminalBlocksInfo = _.cloneDeep(this.selectionNode.code)
      terminalBlocksInfo.titleText = this.TerminalText
      terminalBlocksInfo.count = this.TerminalNumber
      await this.player.Native.NodeProxy.setNodeInfo(this.selectionNode.nodePtr, {
        name: this.TerminalText,
        code: JSON.stringify(terminalBlocksInfo),
      })
      if (isJSONObj(tagNodeInfo.code)) {
        const tagNodeData = JSON.parse(tagNodeInfo.code)
        const guid = generateGUID()
        const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${tagNodeData.md5}/${guid}.png`
        const canvas = document.createElement('canvas')
        canvas.width = 100
        canvas.height = 30
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffff00'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.font = 'bold 12px arial'
        ctx.textAlign = 'center'
        ctx.fillStyle = '#000000'
        ctx.fillText(this.TerminalText, 50, 18)
        const imgUrl = canvas.toDataURL('image/png')
        canvas.remove()
        await this.player.Native.File.downloadFile(url, 'GET', imgUrl, {}, async (res) => {
          const childNode = await this.player.Native.NodeProxy.getNodeChildren(tagNode)
          const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(
            childNode[0].nodePtr
          )
          if (materialPtr) {
            const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
            await this.player.Native.NodeProxy.setNodeMaterial(childNode[0].nodePtr, copyMaterial)
            await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, url)
          }
          await this.player.Native.NodeProxy.setNodeInfo(tagNode, {
            code: JSON.stringify({
              type: 'TerminalBlocksTag',
              fileType: tagNodeData.fileType,
              filePath: tagNodeData.filePath,
              documentId: tagNodeData.documentId,
              documentName: tagNodeData.documentName,
              documentCode: tagNodeData.documentCode,
              md5: tagNodeData.md5,
              materialFileMd5: '',
              model: tagNodeData.model,
              tagInfo: {
                text: this.TerminalText,
                id: guid,
                file: url,
              },
            }),
          })
        })
      }
    },
    // 获取标签的文件路径id
    async getTagFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '标签',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '标签'
          })
          if (currentFolder) {
            this.defaultTagFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取端子头文件路径id
    async getDZPHeadFolderId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '端子头',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '端子头'
          })
          if (currentFolder) {
            this.defaultDZPHeadFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取标签列表
    async getModelTagList() {
      if (this.defaultTagFolderId) {
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultTagFolderId,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
        }
        const res = await DocumentManagementService.advancedSearch(query)
        if (res && res.code === 0 && res.data) {
          this.tagDataList = res.data.items
        }
      }
    },
    // 获取标签列表
    async getDZPHeadList() {
      if (this.defaultDZPHeadFolderId) {
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultDZPHeadFolderId,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          startTime: '',
          keyWord: 'DZP_Head',
        }
        const res = await DocumentManagementService.advancedSearch(query)
        if (res && res.code === 0 && res.data) {
          this.terminalHeadList = res.data.items
        }
      }
    },
    // 模型加载相关
    // 加载模型
    async createNode(data) {
      if (_.isEmpty(data.documentDataList)) {
        this.$message.warning('请选择设备进行添加')
        return
      }
      this.currentCreateParams = _.cloneDeep(data)
      if (this.currentCreateParams.positionType === 'anchor') {
        this.nodePosition = await this.player.Native.Camera.getAnchorPos()
      } else if (this.currentCreateParams.positionType === 'faceCenter') {
        if (this.currentNodeData.item) {
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(
            this.currentNodeData.item
          )
          this.nodePosition = Aabb.faceCenter(calcData.aabb, this.currentCreateParams.faceValue)
        } else {
          this.$message.warning('请选择节点')
          return
        }
      }
      _.forEach(this.currentCreateParams.documentDataList, (item) => {
        this.getDocumentFileList(item)
      })
    },
    async getTerminalPositionInfo(node) {
      const calcData = await this.player.Native.ModelTree.calcItemAabbData(node.item)
      const nodePositionZN = Aabb.faceCenter(calcData.aabb, 'ZN')
      const nodePositionZ = Aabb.faceCenter(calcData.aabb, 'Z')
      return nodePositionZ[2] - nodePositionZN[2]
    },
    // 获取查找文档关联文件
    async getDocumentFileList(data) {
      const res = await DocumentManagementService.getFileList({
        id: data.id,
      })
      if (res && res.data) {
        this.checkModel(res.data)
      }
    },
    /**
     * @description: 检查是否模型是否存在 不存在则下载
     * @param {*}
     * @return {*}
     */
    async checkModel(modelParams) {
      const currentModelFile = _.find(modelParams, (item) => {
        return item.fileType === '.pr' || item.fileType === '.fbx'
      })
      if (!currentModelFile) {
        this.$message.error('当前项目没有模型')
        return
      }
      const currentZip = _.find(modelParams, ['fileType', '.zip'])
      if (currentZip) {
        this.checkModelMaterial(currentZip, currentModelFile)
      } else {
        this.getCurrentModelFile(currentModelFile, {})
      }
    },

    // 检查模型材质文件
    async checkModelMaterial(item, modelParams) {
      // eslint-disable-next-line no-await-in-loop
      const result = await this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      const exists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`
      )
      if (item.md5 === result && exists) {
        this.getCurrentModelFile(modelParams, item)
      } else {
        this.downloadMaterialFile(item.md5, item, modelParams)
      }
    },

    // 检查模型是否存在
    getCurrentModelFile(item, materialParams) {
      this.player.Native.File.getFileMd5(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
        (res) => {
          if (res === item.md5) {
            // 有模型就加载模型
            this.addModel(
              item.md5,
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${item.md5}/${item.md5}${item.fileType}`,
              item,
              materialParams
            )
          } else {
            // 校验md5失败
            this.downloadFile(item.md5, item.fileType, item, materialParams)
          }
        }
      )
    },

    // 下载材质文件
    async downloadMaterialFile(md5, item, modelParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMaterialMsg(modelParams.md5, item, modelParams)
      )
      const res = await this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${modelParams.md5}/${modelParams.md5}.zip`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` }
      )
      // 代表创建下载任务成功
      if (res) {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      } else {
        this.$message.warning('下载材质文件失败')
      }
    },

    /**
     * @description: 下载模型
     * @param {*} playerName：模型名称
     * @param {*} type： 模型类型
     * @return {*}
     */
    async downloadFile(md5, type, item, materialParams) {
      this.player.Native.File.EventDownloadProcessChanged.connect(this.progressMsg)
      this.player.Native.File.EventDownloadFinish.connect(
        this.downloadMsg(md5, item, type, materialParams)
      )
      this.player.Native.File.downloadFile(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
        'GET',
        `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${md5}`,
        { Authorization: `${this.fullToken}` },
        (res) => {
          // 代表创建下载任务成功
          if (res) {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          } else {
            this.$message.warning('下载模型失败')
          }
        }
      )
    },
    // 监听下载模型是否成功
    downloadMsg(md5, item, type, materialParams) {
      const that = this
      const fun = async (file, err) => {
        that.loadPercentage = 0
        that.showLoadProgress = false
        if (err) {
          that.$message.warning(`下载文件失败，${file}, ${err}`)
          return
        }
        if (
          file ===
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          // 检查当前md5和远程下载的md5是否一致
          that.player.Native.File.getFileMd5(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}${type}`,
            (res) => {
              if (res !== md5) {
                that.$message.warning('当前请求的md5和服务器下载的md5不一致！')
              }
            }
          )
          that.addModel(md5, file, item, materialParams) // 模型下载成功就加载模型
        }
      }
      return fun
    },

    // 监听下载模型是否成功
    downloadMaterialMsg(md5, item, modelParams) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载材质文件失败，${file}, ${err}`)
          return
        }
        if (
          file === `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${md5}/${md5}.zip`
        ) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          that.player.Native.File.EventDownloadProcessChanged.disconnect(that.progressMsg)
          await this.player.Native.UiQt.decompressingZIP(file, '')
          setTimeout(() => {
            that.getCurrentModelFile(modelParams, item)
          }, 1500)
        }
      }
      return fun
    },

    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    checkModelLoad(data) {
      this.loadType = '加载中...'
      this.showLoadProgress = true
      this.loadPercentage = data * 100
    },
    /**
     * @description: 监听模型加载完成
     * @param {*} data
     * @return {*}
     */
    checkModelLoadEnd(data) {
      this.showLoadProgress = false
      this.player.Native.Model.EventProgress.disconnect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 获取文档属性模板信息
    async getDocDetail(id) {
      const res = await DocumentManagementService.getDocumentEdite({
        id,
      })
      if (res && res.code === 0 && res.data) {
        if (!_.isEmpty(res.data.templateAttrSetList)) {
          const val = _.find(res.data.templateAttrSetList[0].attrValueList, (el) => {
            return el.fieldName === 'type'
          })
          return val ? val.attrValue : ''
        }
      }
      return ''
    },
    // 加载模型
    async addModel(md5, url, item, materialParams) {
      this.player.Native.Model.EventProgress.connect(this.checkModelLoad)
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      let modelName = ''
      if (this.currentCreateParams.type === 'TerminalHead') {
        modelName = await this.getDocDetail(item.documentId)
      } else {
        modelName = this.currentTerminalModel
      }
      const rootItems = await this.player.Native.ModelTree.getRootItems()
      const currentRoot = _.find(rootItems, (val) => {
        return val.code && JSON.parse(val.code) && JSON.parse(val.code).type === 'Root'
      })
      const rootNode =
        !_.isNil(currentRoot) && currentRoot.nodePtr
          ? currentRoot.nodePtr
          : await this.player.Native.NodeProxy.rootNode()
      let parentNode = this.currentNodeData.nodePtr ? this.currentNodeData.nodePtr : rootNode
      if (this.currentCreateParams.modifyNode && this.currentCreateParams.modifyNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.currentCreateParams.modifyNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.currentCreateParams.modifyNode.nodePtr)
        if (this.currentNodeData.nodePtr === this.currentCreateParams.modifyNode.nodePtr) {
          parentNode = this.currentCreateParams.modifyNode.parentPtr
        }
        this.currentCreateParams.modifyNode = null
        this.selectionNode = null
      }
      const nodeName =
        // eslint-disable-next-line no-nested-ternary
        this.currentCreateParams.type === 'TerminalBlocks'
          ? this.selectionNode
            ? `${item.documentName}${this.totalTerminalCount + (this.increasedCount + 1) * 1}`
            : `${this.dataName}${this.circulateNumber + 1}`
          : this.currentCreateParams.name || item.documentName
      if (item.fileType === '.pr') {
        this.currentCreatedNode = await loadPrModel(
          url,
          nodeName,
          this.selectionNode ? this.selectionNode.nodePtr : this.terminalParent || parentNode,
          this.player
        ) // 加载模型
      } else if (item.fileType === '.fbx') {
        this.currentCreatedNode = await loadFbxModel(
          url,
          nodeName,
          this.selectionNode ? this.selectionNode.nodePtr : this.terminalParent || parentNode,
          this.player
        )
      } else {
        this.currentCreatedNode = await this.player.Native.NodeProxy.loadModelNode(
          nodeName,
          url,
          this.currentCreateParams.name || item.documentName
        ) // 加载模型
      }
      if (this.currentCreateParams.type === 'TerminalBlocks') {
        this.currentTerMinalMd5 = md5
        this.currentTerminalFile = url
        this.currentTerminalInfo = _.cloneDeep(item)
        this.currentTerminalMaterial = _.cloneDeep(materialParams)
        if (this.circulateNumber === 0 && !this.selectionNode) {
          const parentNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(this.terminalParent)
          const calcData = await this.player.Native.ModelTree.calcItemAabbData(parentNodeInfo.item)
          this.nodePosition = Aabb.faceCenter(calcData.aabb, 'ZN')
        }
        const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(this.currentCreatedNode)
        const nodeHeight = await this.getTerminalPositionInfo(nodeInfo)
        const value =
          this.circulateNumber === 0 && !this.selectionNode
            ? this.nodePosition[2] - nodeHeight * 0.5
            : this.nodePosition[2] - nodeHeight
        this.nodePosition.splice(2, 1, value)
      }
      await this.player.Native.NodeProxy.setGlobalTranslation(
        this.currentCreatedNode,
        this.nodePosition
      )
      await this.player.Native.NodeProxy.setNodeInfo(this.currentCreatedNode, {
        code: JSON.stringify({
          type: this.currentCreateParams.type,
          fileType: item.fileType,
          filePath: url,
          documentId: item.documentId,
          documentName: item.documentName,
          documentCode: item.documentCode,
          md5,
          materialFileMd5: materialParams.md5,
          model: modelName,
          count: this.TerminalNumber,
          titleText: this.TerminalText,
        }),
      })
      if (this.currentCreateParams.type === 'TerminalHead') {
        this.terminalParent = this.currentCreatedNode
        const terminalHeadNodeInfo = await this.player.Native.NodeProxy.getNodeInfo(
          this.currentCreatedNode
        )
        this.terminalHeadCalcAabb = await this.player.Native.ModelTree.calcItemAabbData(
          terminalHeadNodeInfo.item
        )
        await this.drawTagInfo(this.currentCreatedNode, this.TerminalText)
        this.loadTerminalBlocksNode()
      } else if (this.selectionNode) {
        this.increasedCount += 1
      } else {
        console.log(this.circulateNumber)
        if (this.circulateNumber < this.TerminalNumber - 1) {
          this.circulateNumber += 1
        } else {
          await this.getTerminalList()
          this.circulateNumber = 0
          this.TerminalNumber = 0
          this.terminalParent = null
          _.forEach(this.deviceList, (el) => {
            el.select = false
          })
          this.currentTerMinalMd5 = ''
          this.currentTerminalFile = ''
          this.currentTerminalInfo = {}
          this.currentTerminalMaterial = {}
          this.currentTerminalModel = null
          this.$emit('updateEditTree', this.currentCreatedNode)
        }
      }
    },
    // 绘制机柜标签
    async drawTagInfo(node, name) {
      const tagInfo = _.find(this.tagDataList, ['name', 'Title_Small'])
      const res = await DocumentManagementService.getFileList({
        id: tagInfo.id,
      })
      if (res && res.data) {
        this.currentTagFile = _.find(res.data, (item) => {
          return item.fileType === '.pr' || item.fileType === '.fbx'
        })
        if (this.currentTagFile) {
          const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.currentTagFile.md5}/${this.currentTagFile.md5}${this.currentTagFile.fileType}`
          const exists = await this.player.Native.File.exists(url)
          if (exists) {
            this.drawNodeMaterial(node, name, url)
          } else {
            this.player.Native.File.EventDownloadFinish.connect(this.downloadTagMsg(node, name))
            this.player.Native.File.downloadFile(
              url,
              'GET',
              `${currentEnv.VUE_APP_PLANT_SERVER}/api/documentfile/getfilecontentasync/${this.currentTagFile.md5}`,
              { Authorization: `${this.fullToken}` }
            )
          }
        }
      }
    },
    // 监听标签文件下载完毕
    async downloadTagMsg(node, name) {
      const that = this
      const fun = async (file, err) => {
        if (!err) {
          that.player.Native.File.EventDownloadFinish.disconnect(fun) // 断开下载
          setTimeout(async () => {
            await that.drawNodeMaterial(node, name, file)
          }, 1500)
        }
      }
      return fun
    },
    // 绘制标签贴图
    async drawNodeMaterial(node, name, file) {
      const guid = generateGUID()
      const url = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.currentTagFile.md5}/${guid}.png`
      const canvas = document.createElement('canvas')
      canvas.width = 100
      canvas.height = 30
      const ctx = canvas.getContext('2d')
      ctx.fillStyle = '#ffff00'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.font = 'bold 12px arial'
      ctx.textAlign = 'center'
      ctx.fillStyle = '#000000'
      ctx.fillText(name, 50, 18)
      const imgUrl = canvas.toDataURL('image/png')
      canvas.remove()
      await this.player.Native.File.downloadFile(url, 'GET', imgUrl, {}, async (res) => {
        await this.setNodeMaterial(node, name, file, url, guid)
      })
    },
    //
    async setNodeMaterial(node, name, file, imgUrl, guid) {
      const modelName = await this.getDocDetail(this.currentTagFile.documentId)
      // 加载标签
      const currentNode = await this.player.Native.NodeProxy.loadModelNode(
        node,
        file,
        this.currentTagFile.documentName
      )
      await this.player.Native.NodeProxy.setLocalScaling(currentNode, [0.31, 1, 0.37])
      const toQuat = EulerAngle.toQuat([0, 0, -90])
      await this.player.Native.NodeProxy.setLocalRotation(currentNode, toQuat)
      const frontFaceCenter = Aabb.faceCenter(this.terminalHeadCalcAabb.aabb, 'XN')
      await this.player.Native.NodeProxy.setGlobalTranslation(currentNode, [
        frontFaceCenter[0] - 0.00001,
        frontFaceCenter[1],
        frontFaceCenter[2],
      ])
      await this.player.Native.NodeProxy.setNodeInfo(currentNode, {
        code: JSON.stringify({
          type: 'TerminalBlocksTag',
          fileType: this.currentTagFile.fileType,
          filePath: file,
          documentId: this.currentTagFile.documentId,
          documentName: this.currentTagFile.documentName,
          documentCode: this.currentTagFile.documentCode,
          md5: this.currentTagFile.md5,
          materialFileMd5: '',
          model: modelName,
          tagInfo: {
            text: name,
            id: guid,
            file: `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/models/${this.currentTagFile.md5}/${guid}.png`,
          },
        }),
      })
      const childNode = await this.player.Native.NodeProxy.getNodeChildren(currentNode)
      const materialPtr = await this.player.Native.NodeProxy.getNodeMaterial(childNode[0].nodePtr)
      if (materialPtr) {
        const copyMaterial = await this.player.Native.NodeProxy.copyMaterial(materialPtr)
        await this.player.Native.NodeProxy.setNodeMaterial(childNode[0].nodePtr, copyMaterial)
        await this.player.Native.NodeProxy.setMaterialTexture(copyMaterial, imgUrl)
      }
    },
    // 模型加载相关
    // 表格选择
    selectionTableChange(selections, row) {
      this.$refs.nodeTable.clearSelection()
      this.selectionNode = row
      this.$refs.nodeTable.toggleRowSelection(row, true)
    },
    // 表格筛选
    filterNodeList() {
      this.dataList = _.filter(this.orignList, (item) => {
        return item.name.search(this.searchKey) >= 0 || item.code.model.search(this.searchKey) >= 0
      })
    },
    // 选择模型切换
    selectChange(data) {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.dataName = data.name
      data.select = true
    },
    // 获取端子排列表
    async getTerminalBlocksList() {
      // 获取当前选中模型子级
      const subNodes = await this.player.Native.NodeProxy.getNodeChildren(
        this.currentNodeData.nodePtr
      )
      const filterList = _.filter(subNodes, (val) => {
        return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'TerminalHead'
      })
      this.orignList = _.map(filterList, (el) => {
        return {
          code: JSON.parse(el.code),
          id: el.id,
          item: el.item,
          name: el.name,
          nodePtr: el.nodePtr,
          parentPtr: el.parentPtr,
          type: el.type,
        }
      })
      this.dataList = _.cloneDeep(this.orignList)
    },
    // 加载端子头
    async loadDZPHead() {
      if (this.TerminalNumber) {
        const currentDoc = _.find(this.terminalHeadList, ['name', 'DZP_Head'])
        const params = {
          TerminalNumber: this.TerminalNumber,
          TerminalText: this.TerminalText,
          modifyNode: this.selectionNode,
          documentDataList: [currentDoc],
          type: 'TerminalHead',
          name: this.TerminalText || '端子排',
          positionType: this.addTypeValue === 1 ? 'anchor' : 'faceCenter',
          faceValue: this.nodePositionValue,
        }
        this.createNode(params)
      } else {
        this.$message.warning('请输入端子排数量')
      }
    },
    // 加载端子排模型节点
    async loadTerminalBlocksNode() {
      const isSelectList = _.filter(this.deviceList, ['select', true])
      const params = {
        TerminalNumber: this.TerminalNumber,
        TerminalText: this.TerminalText,
        modifyNode: this.selectionNode,
        documentDataList: isSelectList,
        type: 'TerminalBlocks',
        name: `${this.dataName}${this.circulateNumber + 1}`,
        positionType: 'TerminalBlocks',
        faceValue: this.nodePositionValue,
      }
      this.currentTerminalModel = await this.getDocDetail(isSelectList[0].id)
      this.createNode(params)
    },
    // 获取端子排的文件路径id
    async getFolderClassId() {
      const res = await DocumentManagementService.getDocumentTree({
        siteId: this.currentProject.id,
        flag: 2,
        keyword: '端子排',
      })
      if (res && res.code === 0 && res.data) {
        const DevicesLibrariesFolder = _.find(res.data, (item) => {
          return item.folderId === this.DevicesLibrariesFolder
        })
        if (DevicesLibrariesFolder) {
          const currentFolder = _.find(DevicesLibrariesFolder.children, (item) => {
            return item.name === '端子排'
          })
          if (currentFolder) {
            this.defaultFolderId = currentFolder.folderId
          }
        }
      }
    },
    // 获取属性模板
    async getAttributeTemplateList() {
      const res = await DocumentManagementService.getTemplateByClassId({
        classId: this.DevicesClassId,
      })
      if (res && res.code === 0 && res.data) {
        if (res.data.templateAttrSetList) {
          this.templateAttrSetList = _.cloneDeep(res.data.templateAttrSetList)
        }
      }
    },
    // 获取端子排列表
    async getDataList() {
      if (this.defaultFolderId) {
        this.listLoading = true
        const query = {
          classIds: [],
          endTime: '',
          flag: '',
          folderId: this.defaultFolderId,
          isRecursion: true,
          pageno: 1,
          pagesize: 9999,
          searchItems: [],
          siteId: this.currentProject.id,
          keyWord: this.searchTypeKey,
          startTime: '',
        }
        // // 拼接属性模板搜索条件
        // if (this.templateAttrSetList) {
        //   const attrValue = _.find(this.templateAttrSetList[0].attrValueList, (item) => {
        //     return item.attrbuteDetail.displayName === '型号'
        //   })
        //   query.searchItems = [
        //     {
        //       tableName: this.templateAttrSetList[0].tableName,
        //       tableItems: [
        //         {
        //           fieldName: attrValue.fieldName,
        //           fieldValue: this.searchTypeKey,
        //           valueType: attrValue.valueType,
        //         },
        //       ],
        //     },
        //   ]
        // }
        const res = await DocumentManagementService.advancedSearch(query)
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.deviceList = _.map(res.data.items, (item) => {
            return {
              ...item,
              select: false,
            }
          })
        }
      }
    },
    // 端子列表生成
    async getTerminalList() {
      const terminalChilds = await this.player.Native.NodeProxy.getNodeChildren(this.terminalParent)
      const terminalList = _.filter(terminalChilds, (item) => {
        return isJSONObj(item.code) && JSON.parse(item.code).type === 'TerminalBlocks'
      })
      this.TerminalObjList = _.map(terminalList, (item) => {
        return { number: item.name }
      })
    },
    // 取消编辑
    cancleModify() {
      _.forEach(this.deviceList, (item) => {
        item.select = false
      })
      this.TerminalObjList = []
      this.TerminalText = ''
      this.TerminalNumber = 0
      this.selectionNode = null
      this.isEdit = false
      setTimeout(() => {
        this.getTerminalBlocksList()
        this.$refs.nodeTable.clearSelection()
      }, 500)
    },
    // 去到新增页面
    addNode() {
      this.isEdit = true
    },
    // 去到编辑
    async editNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择模型修改模型')
        return
      }
      this.currentNodeName = this.selectionNode.name
      this.isEdit = true
      if (this.selectionNode.code) {
        this.TerminalText = this.selectionNode.code.titleText
        this.TerminalNumber = this.selectionNode.code.count
        _.forEach(this.deviceList, (item) => {
          if (item.id === this.selectionNode.code.documentId) {
            item.select = true
          }
        })
        if (this.selectionNode.nodePtr) {
          const childs = await this.player.Native.NodeProxy.getNodeChildren(
            this.selectionNode.nodePtr
          )
          this.TerminalObjList = _.map(
            _.filter(childs, (el) => {
              return isJSONObj(el.code) && JSON.parse(el.code).type === 'TerminalBlocks'
            }),
            (item) => {
              return { number: item.name }
            }
          )
        }
      }
    },
    // 删除节点
    async deleteNode() {
      if (!this.selectionNode) {
        this.$message.warning('请选择需要删除的模型')
        return
      }
      if (this.selectionNode.nodePtr) {
        const editNode = await this.player.Native.NodeEditor.node()
        if (editNode === this.selectionNode.nodePtr) {
          await this.player.Native.NodeEditor.setNode(0)
        }
        await this.player.Native.NodeProxy.destroyNode(this.selectionNode.nodePtr)
        this.selectionNode = null
        this.$refs.nodeTable.clearSelection()
        this.getTerminalBlocksList()
        this.$emit('updateEditTree', '')
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../../css/index.scss';
@import '../../../css/select.scss';
#TerminalBlocks {
  width: 100%;
  height: 100%;
}
/deep/.player_progress {
  position: fixed !important;
}
/deep/ .el-table__header-wrapper .el-checkbox {
  display: none !important;
}
/deep/.el-checkbox__label {
  font-size: 12px !important;
  max-width: 80px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list {
  height: calc(100% - 48px);
  background-color: rgba(24, 41, 72, 0.5);
  .table-content {
    height: calc(100% - 42px);
  }
}
.create_new {
  z-index: 999;
  position: absolute;
  bottom: 15px;
  right: 20px;
}
.card-footer {
  border: none !important;
}
.Terminal_top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 5px 5px 10px;
  background-color: rgba(24, 41, 72, 0.5);
  span {
    height: 36px;
    line-height: 36px;
  }
}
.terminal-table {
  background-color: rgba(24, 41, 72, 0.5);
}
.Terminal_bottom {
  width: 100%;
  overflow: auto;
  background-color: rgba(24, 41, 72, 0.5);
  .model {
    background-color: rgba(24, 41, 72, 0.5);
    height: 125px;
    z-index: 999;
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    .model_card {
      margin: 10px 10px;
      width: 80px;
      height: 100px;
      .img-card {
        background-color: #383b3b !important;
      }
      img {
        height: 76px;
      }
    }
  }
}
.terminal-count-title:before {
  content: '*';
  color: #f5222d;
  margin-right: 4px;
  line-height: 36px;
}

</style>
